module.exports = __webpack_public_path__ + "img/team_active.e0433149.svg";